import { PublicQuestionnaire } from '../translations-types';

const translations: PublicQuestionnaire = {
  intro: 'Enter your details to start the questionnaire.',
  nameLabel: 'Name',
  emailLabel: 'Email address',
  sendCode: 'Send verification code',
  codeIntro: 'We sent a verification code to your email address.',
  codeLabel: 'Verification code',
  verify: 'Confirm and start',
  nameRequired: 'Please enter your name.',
  emailRequired: 'Please enter your email address.',
  invalidEmail: 'Please enter a valid email address.',
  codeRequired: 'Please enter the code.',
  error: 'Something went wrong. Please try again.',
};

export default translations;
